import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import connect from 'components/lib/connect';
import ExpandTransaction from 'actions/customer_profile/expand_transaction';
import ExpandableProfileCard from 'components/customer/profile/expandable_profile_card';
import FlightTransactions from './transactions/flight_transactions';
import OrderTransactions from './transactions/order_transactions';
import ProfileCardDef, { ProfileCardType } from 'models/configuration/profile_card_def';
import StayTransactions from './transactions/stay_transactions';
import Transaction from 'models/transaction';
import {
  FlightTransactionDef,
  GenericTransactionDef,
  OrderTransactionDef,
  StayTransactionDef,
} from 'models/configuration/transaction_def';
import { renderCustomAttributes } from './lib/custom_attributes_helper';

export function CustomerTransaction({ transaction, transactionDef }) {
  if (!transactionDef || !transaction || !transaction.attributes) {
    return null;
  }

  const attrDefs = _.filter(transactionDef.attributes, attrDef => !!transaction.attributes[attrDef.attr]);
  if (!attrDefs.length) {
    return null;
  }

  return (
    <div className="customerTransaction">
      {renderCustomAttributes(attrDefs, transaction.attributes, ProfileCardType.TRANSACTIONS)}
    </div>
  );
}

CustomerTransaction.propTypes = {
  transactionDef: PropTypes.instanceOf(GenericTransactionDef),
  transaction: PropTypes.instanceOf(Transaction),
};

export function CustomerTransactions({ isLoading, transactionDef, transactions, onExpand, profileCardDef }) {
  if (!isLoading && (!transactionDef || !transactions)) {
    return null;
  }

  if (transactionDef instanceof OrderTransactionDef) {
    return (
      <OrderTransactions
        isLoading={isLoading}
        onExpand={onExpand}
        profileCardDef={profileCardDef}
        transactionDef={transactionDef}
        transactions={transactions}
      />
    );
  } else if (transactionDef instanceof FlightTransactionDef) {
    return (
      <FlightTransactions
        isLoading={isLoading}
        onExpand={onExpand}
        profileCardDef={profileCardDef}
        transactionDef={transactionDef}
        transactions={transactions}
      />
    );
  } else if (transactionDef instanceof StayTransactionDef) {
    return (
      <StayTransactions
        isLoading={isLoading}
        now={moment().format()}
        onExpand={onExpand}
        profileCardDef={profileCardDef}
        transactionDef={transactionDef}
        transactions={transactions}
      />
    );
  }

  // We don't want to show transactions for other types to not interfere with demos
  if (!transactions.length) {
    return null;
  }

  const renderedTransactions = _.map(transactions, transaction => (
    <CustomerTransaction transactionDef={transactionDef} key={transaction.id} transaction={transaction} />
  ));

  return (
    <ExpandableProfileCard isLoading={isLoading} title={(profileCardDef && profileCardDef.label) || 'Transactions'}>
      {renderedTransactions}
    </ExpandableProfileCard>
  );
}

CustomerTransactions.propTypes = {
  isLoading: PropTypes.bool,
  onExpand: PropTypes.func,
  profileCardDef: PropTypes.instanceOf(ProfileCardDef),
  transactionDef: PropTypes.oneOfType([
    PropTypes.instanceOf(GenericTransactionDef),
    PropTypes.instanceOf(FlightTransactionDef),
    PropTypes.instanceOf(OrderTransactionDef),
    PropTypes.instanceOf(StayTransactionDef),
  ]),
  transactions: PropTypes.arrayOf(PropTypes.instanceOf(Transaction)),
};

function mapStateToProps({ getProvider }, { profileCardDef }) {
  let profileDefProvider = getProvider('customerProfileDef');
  let profileProvider = getProvider('profile');
  let transactionsProvider = getProvider('transactions');

  const isLoading = profileProvider.isLoading() || profileDefProvider.isLoading() || transactionsProvider.isLoading();
  const profileDef = profileDefProvider.get();

  return {
    isLoading,
    transactionDef: profileDef && profileDef.transaction,
    transactions: transactionsProvider.findAll(),
    profileCardDef,
  };
}

function mapExecuteToProps(executeAction) {
  return {
    onExpand: ({ isExpanded }) => executeAction(ExpandTransaction, { isExpanded }),
  };
}

const CustomerTransactionContainer = connect(mapStateToProps, mapExecuteToProps)(CustomerTransactions);
export default CustomerTransactionContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/summary/customer_transactions.jsx